import TRC_PAGE_CATEGORIES from '../../../../constants/trcCategories';
import Actions from './actions';
import Description from './description';

const Content = ({ content, setPdfView }) => {
	
	return (
		<div className="d-flex flex-column justify-content-between" style={{ height: '100%' }}>
			<Description content={content} />
			<Actions content={content} category={TRC_PAGE_CATEGORIES.LESSON_PLANS} setPdfView={setPdfView} />
		</div>
	);
};

export default Content;
